;
(function ($, window, history) {

    // Create the defaults once 
    var componentName = 'accordionHistoryLocation',
            defaults = {
                selector: '[data-toggle="collapse"]'
            };

    // The actual plugin constructor 
    function Component(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = componentName;

        this.hash = window.location.hash;

        this.init();
    }

    // Component methods 
    Component.prototype = {
        init: function () {
            // set active tab if we have a hash
            this.hash && $(this.element).find(this.hash).collapse('show');
            this._listenAccordionChange();
        },
        _listenAccordionChange: function () {
            $(this.element).find(this.options.selector).click(function (e) {
//                var scrollmem = $('body').scrollTop();console.log(scrollmem);
//                window.location.hash = this.hash;
//                window.setTimeout(function(){
//                    $('html,body').scrollTop(scrollmem);
//                }, 0);
                if (history.pushState)
                    history.pushState(null, null, this.hash);
            });
        }
    };

    $.fn[componentName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'component_' + componentName)) {
                $.data(this, 'component_' + componentName,
                        new Component(this, options));
            }
        });
    };

})(jQuery, window, history);
